import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-add-task',
  templateUrl: './add-task.component.html',
  styleUrls: ['./add-task.component.css']
})
export class AddTaskComponent implements OnInit {

  i: any;
  deleteId: any;
  id: any;
  task:any = []
  tagUsersdropdownList  = [];
  tagUsersselectedItems:any = [];
  tagUsersdropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'userName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  usersList: any= []
  assignInput = ""
  addClassType = ""
  statusNote = false;
  statusNoteText = ""
  userIdList = [];
  taskType = "All"
  taskMasters:any = []
  cid:any
  usersWithoutCustomers:any = []

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  form: any | FormGroup
  modelSubtitle = false
  fileType:any;
  file!: File;
  tasks:any = []
  images:any= [];
  videos:any= [];
  audios:any= [];
  name = ""
  description = ""
  assignedTo = ""
  searchFilter = ''
  taskId = ""
  note = ""
  taskStatus = ""
  formSubmit = false
  addButton = false

  ProductParams:any = []
  keyValueList:any = []

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getUsers()
    this.getUsersWithoutCustomers()
    this.getAllTaskNameAndDescription()
    this.form = this.fb.group({
      name: ['',[Validators.required]],
      description: [''],
      assignedTo: [''],
      tagUserIds: [''],
      taskExpStartDate: [''],
      taskExpEndDate: [''],
    });
    this.getParamByType()
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  getParamByType(){
    this.generic_service.getParamByType('TASKPARAM').subscribe(
      (response:any)=>{
        console.log(response);
        this.ProductParams = response.response;
        console.log(this.ProductParams);

        for(let i=0; i<this.ProductParams.length;i++){
          this.keyValueList.push(
            {
              "key": this.ProductParams[i].name,
              "value": "",
              "possibleValue": this.ProductParams[i].possibleValue
            }
          )
        }
        console.log(this.keyValueList);

      }
    )
  }

  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
        this.tagUsersdropdownList = res.response;
      }
    )
  }

  getUsersWithoutCustomers(){
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res:any)=>{
        this.usersWithoutCustomers = res.response;
      }
    )
  }

  addTask(){
    this.formSubmit = true;
    if(!this.form.valid){
      console.log(this.form.value)
      return
    }
    this.addButton = true;

    let tagUserIds = [];
    for(let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }
    let status = ''
    if(this.form.get('assignedTo').value == ''){
      status = "NEW"
    }else{
      status = "ASSIGNED"
    }

        
    let keyValueList:any = []

    for(let i = 0; i < this.keyValueList.length; i++){
      keyValueList.push(
        {
          "key": this.keyValueList[i].key,
          "value": this.keyValueList[i].value
        }
      )
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "taskRegType": "string",
      "taskRegId": "string",
      "taskSINumber": 0,
      "taskListingNumber": 0,
      "assignedTo": String(this.form.get('assignedTo').value),
      "taskExpStartDate": new Date(this.form.get('taskExpStartDate').value).getTime(),
      "taskExpEndDate": new Date(this.form.get('taskExpEndDate').value).getTime(),
      "taskActStartDate": 0,
      "taskActEndDate": 0,
      "taskExpDuration": 0,
      "taskActDuration": 0,
      "status": [
        {
          "note": "string",
          "taskStatus": status,
          "updatedDate": 0
        }
      ],
      "completedPercentage": 0,
      "keyValueList": keyValueList,
      "notes": "string",
      "audio": this.audios,
      "video": this.videos,
      "image": this.images,
      "tagUserIds": tagUserIds,
      "name": String(this.form.get('name').value),
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.addTask(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.toastr.success(response.message);
        this.form.reset();
        this.cancelModel()
        this.images = []
        this.formSubmit = false;
        this.addButton = false;
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
        this.addButton = false;
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  onSelectFile(event:any){
    if(event.target.files){
      console.log(event.target.files[0])
      console.log(event.target)
      console.log(event)

      var reader = new FileReader;
      reader.readAsDataURL(event.target.files[0]);
      reader.onload=(e:any)=>{
        console.log(e)
        this.file=e.target.result;
        this.generic_service.uploadImage(e.target.result).subscribe(
          (response:any)=>{
            console.log(response)
            this.images.push(response.response)
          },
          (err:any)=>{
            console.log(err)
          }
        )
      }
    }
  }


onChange(event: any) {
  this.file = event.target.files[0];
  this.onUpload()
}

onUpload() {
  console.log(this.file);
  this.generic_service.uploadImage(this.file).subscribe((event: any) => {
    console.log(event);
    this.images.push(event.response)

  });
}

  addImageBtn(){
    document.getElementById("add-image-btn")?.click()
  }

  addVideoBtn(){
    document.getElementById("add-video-btn")?.click()
  }

  addAudioBtn(){
    document.getElementById("add-audio-btn")?.click()
  }

  getAllTaskNameAndDescription(){
    this.generic_service.getAllTaskNameAndDescription().subscribe(
      (response:any)=>{
        console.log(response)
        this.taskMasters = response.response
        console.log(this.taskMasters)

      }
    )
  }

  autoFill(taskName: any,taskDescription:any){
    this.form.get('name').setValue(taskName);
    this.form.get('description').setValue(taskDescription);
    this.cancelModel()
  }
}